import React, { Dispatch, SetStateAction } from 'react';
import { List, ListItem, ListItemText, Menu, MenuItem, Theme, Typography } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import personaMappingJson from '../../personas/personaMapping.json';


interface AlmeTenantMenuProps {
    setAccessKey: Dispatch<SetStateAction<string>>;
}

const useStyles = makeStyles(({ palette, spacing }: Theme) =>
    createStyles({
        root: {
            padding: spacing(1),
        },
        menu: {
            width: '60%',
            backgroundColor: palette.background.paper,
        },
    }),
);

const personaNames = personaMappingJson.map(persona => persona.name);

const AlmeTenantMenu: React.FC<AlmeTenantMenuProps> = (props: AlmeTenantMenuProps) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [selectedIndex, setSelectedIndex] = React.useState(0);

    const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
        setSelectedIndex(index);
        setAnchorEl(null);
        const selectedPersona = personaMappingJson.find(persona => persona.name === personaMappingJson[index].name);
        if (selectedPersona?.verintAccessKey) {
            props.setAccessKey(selectedPersona.verintAccessKey);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={classes.root}>
            <Typography>Select access key from dropdown menu (must use Launch IVA button)</Typography>
            <div className={classes.menu}>
                <List component="nav">
                    <ListItem
                        button
                        aria-haspopup="true"
                        aria-controls="alme-tenant-menu"
                        onClick={handleClickListItem}
                    >
                        <ListItemText primary={personaNames[selectedIndex]} />
                    </ListItem>
                </List>
                <Menu
                    id="alme-tenant-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    {personaNames.map((option, index) => (
                        <MenuItem
                            key={option}
                            selected={index === selectedIndex}
                            onClick={(event) => handleMenuItemClick(event, index)}
                        >
                            {option}
                        </MenuItem>
                    ))}
                </Menu>
            </div>
        </div>
    );
};

export default AlmeTenantMenu;
